<template>
  <div class="mama-explorer">
    <p class="titulo">IV. Datos clínicos — Localización y signos</p>

    <div class="main-grid">
      <!-- CONTENEDOR DE MAMAS CON SILUETA -->
      <div class="mamas-container">
        <div class="mamas-header">
          <span class="side-label">Derecha</span>
          <span class="side-label">Izquierda</span>
        </div>

        <div class="silhouette-wrapper">
          <svg class="silhouette-svg" viewBox="0 0 600 550">
            <defs>
              <!-- Gradientes para volumen y piel natural -->
              <linearGradient id="bodyGrad" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" y2="550">
                <stop offset="0%" stop-color="#F4BC9A" />
                <stop offset="50%" stop-color="#F2B090" />
                <stop offset="100%" stop-color="#E8A078" />
              </linearGradient>

              <radialGradient id="breastGrad" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stop-color="#F9D5B0" stop-opacity="0.55" />
                <stop offset="70%" stop-color="#F2B090" stop-opacity="0.1" />
                <stop offset="100%" stop-color="#F2B090" stop-opacity="0" />
              </radialGradient>

              <linearGradient id="topBlurGrad" gradientUnits="userSpaceOnUse" x1="0" y1="185" x2="0" y2="280">
                <stop offset="0%" stop-color="#E09070" stop-opacity="0.15" />
                <stop offset="30%" stop-color="#F2B090" stop-opacity="0.3" />
                <stop offset="100%" stop-color="#F2B090" stop-opacity="0" />
              </linearGradient>

              <filter id="softBlur" x="-50%" y="-50%" width="200%" height="200%">
                <feGaussianBlur in="SourceGraphic" stdDeviation="4" />
              </filter>

              <filter id="softShadow" x="-20%" y="-20%" width="140%" height="140%">
                <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
                <feOffset dx="0" dy="2" result="offsetblur" />
                <feComponentTransfer>
                  <feFuncA type="linear" slope="0.2" />
                </feComponentTransfer>
                <feMerge>
                  <feMergeNode />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>

              <!-- Gradiente Areolas (Borde Difuminado) -->
              <radialGradient id="areolaGradD" cx="50%" cy="50%" r="50%">
                <stop offset="75%" stop-color="#D48A6A" />
                <stop offset="100%" stop-color="#E8977A" stop-opacity="0" />
              </radialGradient>
              <radialGradient id="areolaGradI" cx="50%" cy="50%" r="50%">
                <stop offset="75%" stop-color="#D48A6A" />
                <stop offset="100%" stop-color="#E8977A" stop-opacity="0" />
              </radialGradient>

              <!-- Gradiente Pezones (Borde Difuminado) -->
              <radialGradient id="nippleGrad" cx="50%" cy="50%" r="50%">
                <stop offset="70%" stop-color="#A85838" />
                <stop offset="100%" stop-color="#B05838" stop-opacity="0.3" />
              </radialGradient>

              <!-- ClipPaths ajustados: Radio de 80 para alinear con el volumen visual y evitar desbordes -->
              <clipPath id="clipD">
                <ellipse cx="155" cy="330" rx="80" ry="80" />
              </clipPath>
              <clipPath id="clipI">
                <ellipse cx="405" cy="330" rx="80" ry="80" />
              </clipPath>
            </defs>

            <!-- ===== CUERPO COMPLETO (Torso natural y brazos integrados) ===== -->
            <g filter="url(#softShadow)">
              <path d="
                M 245,20
                C 245,20 242,40 238,65
                C 230,90 180,105 130,125
                C 100,140 65,165 50,195
                C 35,225 30,280 25,350
                C 20,420 25,480 35,550
                L 85,550
                C 105,480 115,420 120,350
                C 125,280 135,245 150,230
                C 180,210 145,390 145,390
                C 180,410 115,475 105,550
                L 455,550
                C 445,475 380,410 415,390
                C 415,390 385,210 410,230
                C 420,245 425,280 435,350
                C 445,420 455,480 475,550
                L 525,550
                C 540,480 550,420 545,350
                C 540,280 535,225 515,195
                C 500,165 460,140 430,125
                C 380,105 330,90 322,65
                C 318,40 315,20 315,20
                Z
              " fill="url(#bodyGrad)" />
            </g>

            <!-- Detalles -->
            <path d="M 152,230 C 135,255 120,290 120,350" fill="none" stroke="#A05838" stroke-width="1.2"
              opacity="0.2" />
            <path d="M 408,230 C 425,255 440,290 440,350" fill="none" stroke="#A05838" stroke-width="1.2"
              opacity="0.2" />

            <!-- Cuello natural -->
            <path d="M 245,20 C 245,45 250,65 248,85 L 312,85 C 310,65 315,45 315,20 Z" fill="#F4BC9A" />
            <path d="M 248,85 C 280,100 280,100 312,85" fill="none" stroke="#C8805A" stroke-width="1.5" opacity="0.4" />

            <!-- Ombligo (Detalle anatómico sutil) -->
            <path d="M 270,495 C 275,502 285,502 290,495" fill="none" stroke="#C8805A" stroke-width="1.5"
              opacity="0.4" />
            <path d="M 275,496 C 280,498 280,498 285,496" fill="none" stroke="#A05838" stroke-width="1" opacity="0.2" />

            <!-- ===== MAMA DERECHA (Unida y Alta) ===== -->
            <path d="
              M 145,185
              C 105,190 80,215 75,270
              C 70,325 100,380 150,395
              C 180,405 220,398 245,375
              C 275,350 280,310 282,275
              C 278,220 200,178 145,185 Z
            " fill="url(#bodyGrad)" />
            <path d="M 145,185 C 200,178 278,220 282,275 L 145,275 Z" fill="url(#topBlurGrad)"
              filter="url(#softBlur)" />
            <circle cx="145" cy="320" r="85" fill="url(#breastGrad)" pointer-events="none" />

            <path class="outline"
              d="M 75,285 C 73,325 100,380 150,395 C 180,405 220,398 245,375 C 225,388 190,398 162,390 C 115,375 85,335 80,285 Z"
              fill="#D4906A" opacity="0.22" />

            <!-- Cuadrantes D -->
            <g clip-path="url(#clipD)">
              <path :class="zonaClass('D', 1)" d="M155,330 L155,250 A80,80 0 0,1 235,330 Z" @click="selectZona('D', 1)" />
              <path :class="zonaClass('D', 2)" d="M155,330 L75,330 A80,80 0 0,1 155,250 Z" @click="selectZona('D', 2)" />
              <path :class="zonaClass('D', 3)" d="M155,330 L155,410 A80,80 0 0,1 75,330 Z" @click="selectZona('D', 3)" />
              <path :class="zonaClass('D', 4)" d="M155,330 L235,330 A80,80 0 0,1 155,410 Z" @click="selectZona('D', 4)" />
            </g>
            <line x1="155" y1="230" x2="155" y2="395" stroke="rgba(139,80,53,0.15)" stroke-width="1" />
            <line x1="90" y1="330" x2="260" y2="330" stroke="rgba(139,80,53,0.15)" stroke-width="1" />

            <!-- Areola D -->
            <circle cx="155" cy="330" r="28" fill="url(#areolaGradD)" pointer-events="none" />
            <circle cx="155" cy="330" r="10" fill="url(#nippleGrad)" pointer-events="none" />
            <circle :class="pezonClass('D', 5)" cx="155" cy="330" r="10" @click="selectZona('D', 5)" />
            <!-- Labels D -->
            <text class="lbl" x="195" y="315">1</text>
            <text class="lbl" x="115" y="315">2</text>
            <text class="lbl" x="115" y="355">3</text>
            <text class="lbl" x="195" y="355">4</text>
            <text class="lbl" style="font-size: 10px; color: #8B5035;" x="155" y="334" text-anchor="middle">5</text>

            <!-- ===== MAMA IZQUIERDA (Unida y Alta) ===== -->
            <path d="
              M 415,185
              C 455,190 480,215 485,270
              C 490,325 460,380 410,395
              C 380,405 340,398 315,375
              C 285,350 275,310 278,275
              C 282,220 360,178 415,185 Z
            " fill="url(#bodyGrad)" />
            <path d="M 415,185 C 360,178 282,220 278,275 L 415,275 Z" fill="url(#topBlurGrad)"
              filter="url(#softBlur)" />
            <circle cx="415" cy="320" r="85" fill="url(#breastGrad)" pointer-events="none" />

            <path class="outline"
              d="M 485,285 C 487,325 460,380 410,395 C 380,405 340,398 315,375 C 335,388 370,398 398,390 C 445,375 475,335 480,285 Z"
              fill="#D4906A" opacity="0.22" />

            <!-- Cuadrantes I -->
            <g clip-path="url(#clipI)">
              <path :class="zonaClass('I', 9)" d="M405,330 L485,330 A80,80 0 0,0 405,250 Z" @click="selectZona('I', 9)" />
              <path :class="zonaClass('I', 12)" d="M405,330 L405,250 A80,80 0 0,0 325,330 Z"
                @click="selectZona('I', 12)" />
              <path :class="zonaClass('I', 11)" d="M405,330 L325,330 A80,80 0 0,0 405,410 Z"
                @click="selectZona('I', 11)" />
              <path :class="zonaClass('I', 10)" d="M405,330 L405,410 A80,80 0 0,0 485,330 Z"
                @click="selectZona('I', 10)" />
            </g>
            <line x1="405" y1="230" x2="405" y2="395" stroke="rgba(139,80,53,0.15)" stroke-width="1" />
            <line x1="295" y1="330" x2="475" y2="330" stroke="rgba(139,80,53,0.15)" stroke-width="1" />

            <!-- Areola I -->
            <circle cx="405" cy="330" r="28" fill="url(#areolaGradI)" pointer-events="none" />
            <circle cx="405" cy="330" r="10" fill="url(#nippleGrad)" pointer-events="none" />
            <circle :class="pezonClass('I', 13)" cx="405" cy="330" r="10" @click="selectZona('I', 13)" />

            <!-- Labels I -->
            <text class="lbl" x="445" y="315">9</text>
            <text class="lbl" x="365" y="315">12</text>
            <text class="lbl" x="365" y="355">11</text>
            <text class="lbl" x="445" y="355">10</text>
            <text class="lbl" style="font-size: 10px;" x="405" y="334" text-anchor="middle">13</text>

            <!-- ===== ZONAS EXTERNAS ===== -->
            <ellipse :class="extSvgClass('D', 6)" cx="35" cy="285" rx="30" ry="24" @click="selectZona('D', 6)" />
            <text class="ext-lbl" x="35" y="290">6</text>

            <ellipse :class="extSvgClass('D', 7)" cx="115" cy="145" rx="45" ry="22" @click="selectZona('D', 7)" />
            <text class="ext-lbl" x="115" y="150">7</text>

            <ellipse :class="extSvgClass('I', 14)" cx="525" cy="285" rx="30" ry="24" @click="selectZona('I', 14)" />
            <text class="ext-lbl" x="525" y="290">14</text>

            <ellipse :class="extSvgClass('I', 15)" cx="445" cy="145" rx="45" ry="22" @click="selectZona('I', 15)" />
            <text class="ext-lbl" x="445" y="150">15</text>
          </svg>
        </div>

        <div class="ext-btns-row">
          <div class="ext-btns">
            <button v-for="z in zonasExternasDerecha" :key="z.id" :class="extBtnClass('D', z.id)"
              @click="selectZona('D', z.id)">
              {{ z.nombre }} ({{ z.id }})
            </button>
          </div>
          <div class="ext-btns">
            <button v-for="z in zonasExternasIzquierda" :key="z.id" :class="extBtnClass('I', z.id)"
              @click="selectZona('I', z.id)">
              {{ z.nombre }} ({{ z.id }})
            </button>
          </div>
        </div>
      </div>

      <!-- PANEL LATERAL -->
      <div class="panel">
        <p class="panel-t">Signos clínicos</p>
        <p class="panel-sub">
          {{ activeZona ? 'Marca los hallazgos encontrados:' : 'Selecciona una zona' }}
        </p>

        <div v-if="activeZona" class="zona-name">
          {{ nombreZona(activeZona.lado, activeZona.zona) }}
        </div>

        <div class="signos-list">
          <template v-if="activeZona">
            <div v-for="signo in SIGNOS" :key="signo.id" :class="['signo-item', { sel: isSignoSelected(signo.id) }]"
              @click="toggleSigno(signo.id)">
              <div class="signo-check">
                <svg v-if="isSignoSelected(signo.id)" class="check-mark" viewBox="0 0 8 8">
                  <polyline points="1,4 3,6 7,2" stroke="white" stroke-width="1.5" fill="none" />
                </svg>
              </div>
              <span class="signo-txt">{{ signo.txt }}</span>
              <span class="signo-num">{{ signo.id }}</span>
            </div>
          </template>
          <p v-else class="no-zona">
            Haz clic en un cuadrante o zona para registrar hallazgos
          </p>
        </div>

        <!-- RESUMEN -->
        <div v-if="tieneHallazgos" class="resumen">
          <p class="resumen-t">Resumen de hallazgos</p>
          <div v-for="(item, key) in data" :key="key" class="res-item">
            <span class="res-zona">{{ nombreZona(item.lado, item.zona) }}</span>
            <span class="res-signos">{{ getSignosNombres(item.signos) }}</span>
          </div>
          <button class="clear-btn" @click="limpiarTodo">Limpiar todo</button>
        </div>
      </div>
    </div>
    <div>
      <label for="observaciones">Observaciones</label>
      <textarea id="observaciones" v-model="observaciones" class="form-control"></textarea>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button class="btn btn-success float-right btn-sm" @click="guardar"><i class="fas fa-save fa-fw"></i>Guardar
          Examen</button>
      </div>
    </div>
  </div>
</template>

<script>
import Toast from '../../../../components/common/utilities/toast';
import examenClinicoMamaService from '../../../../services/examenClinicoMamaService';

export default {
  name: 'LocalizacionMama',

  props: ['value', 'idHistoria'],

  data() {
    return {
      activeZona: null,
      data: { ...this.value },
      observaciones: '',

      SIGNOS: [
        { id: 1, txt: 'Tumoración palpable' },
        { id: 2, txt: 'Úlcera y/o eczema del pezón' },
        { id: 3, txt: 'Secreción por el pezón' },
        { id: 4, txt: 'Retracción o fijación del pezón' },
        { id: 5, txt: 'Piel de naranja' },
        { id: 6, txt: 'Ganglios axilares y/o supraclav. palpables' },
        { id: 7, txt: 'Cambios en la coloración de la piel' },
        { id: 8, txt: 'Asimetría en las mamas' },
        { id: 9, txt: 'Retracción cutánea' },
        { id: 10, txt: 'Ninguno' },
      ],

      NOMBRES: {
        D: {
          1: 'Cuadrante superior externo Derecho', 2: 'Cuadrante superior interno Derecho',
          3: 'Cuadrante inferior interno Derecho', 4: 'Cuadrante inferior externo Derecho',
          5: 'Pezón Derecho', 6: 'Axila Derecha',
          7: 'Superficie clavicular Derecho', 8: 'Mama derecha',
        },
        I: {
          9: 'Cuadrante superior externo Izquierdo', 10: 'Cuadrante inferior externo Izquierdo',
          11: 'Cuadrante inferior interno Izquierdo', 12: 'Cuadrante superior interno Izquierdo',
          13: 'Pezón Izquierdo', 14: 'Axila Izquierda',
          15: 'Superficie clavicular Izquierdo', 16: 'Mama izquierda',
        }
      },

      zonasExternasDerecha: [
        { id: 6, nombre: 'Axila' },
        { id: 7, nombre: 'Hueco supraclavicular' },
        { id: 8, nombre: 'Mama derecha general' },
      ],

      zonasExternasIzquierda: [
        { id: 14, nombre: 'Axila' },
        { id: 15, nombre: 'Hueco supraclavicular' },
        { id: 16, nombre: 'Mama izquierda general' },
      ],
    }
  },

  computed: {
    tieneHallazgos() {
      return Object.keys(this.data).length > 0
    }
  },

  methods: {
    zkey(lado, zona) {
      return `${lado}_${zona}`
    },

    selectZona(lado, zona) {
      this.activeZona = { lado, zona }
    },

    toggleSigno(signoId) {
      if (!this.activeZona) return
      const k = this.zkey(this.activeZona.lado, this.activeZona.zona)

      if (!this.data[k]) {
        this.$set(this.data, k, {
          lado: this.activeZona.lado,
          zona: this.activeZona.zona,
          signos: []
        })
      }

      const idx = this.data[k].signos.indexOf(signoId)
      if (idx >= 0) {
        this.data[k].signos.splice(idx, 1)
        if (this.data[k].signos.length === 0) {
          this.$delete(this.data, k)
        }
      } else {
        this.data[k].signos.push(signoId)
      }

      this.$emit('input', this.data)
    },

    isSignoSelected(signoId) {
      if (!this.activeZona) return false
      const k = this.zkey(this.activeZona.lado, this.activeZona.zona)
      return this.data[k]?.signos.includes(signoId) ?? false
    },

    zonaClass(lado, zona) {
      const k = this.zkey(lado, zona)
      const isActive = this.activeZona?.lado === lado && this.activeZona?.zona === zona
      return {
        zona: true,
        'has-data': !!this.data[k],
        active: isActive
      }
    },

    pezonClass(lado, zona) {
      const k = this.zkey(lado, zona)
      const isActive = this.activeZona?.lado === lado && this.activeZona?.zona === zona
      return {
        'zona-pezon': true,
        'has-data': !!this.data[k],
        active: isActive
      }
    },

    extBtnClass(lado, zona) {
      const k = this.zkey(lado, zona)
      const isActive = this.activeZona?.lado === lado && this.activeZona?.zona === zona
      return {
        'ext-btn': true,
        'has-data': !!this.data[k],
        active: isActive
      }
    },

    extSvgClass(lado, zona) {
      const k = this.zkey(lado, zona)
      const isActive = this.activeZona?.lado === lado && this.activeZona?.zona === zona
      return {
        'zona-ext': true,
        'has-data': !!this.data[k],
        active: isActive
      }
    },

    nombreZona(lado, zona) {
      return this.NOMBRES[lado]?.[zona] ?? `Zona ${zona}`
    },

    getSignosNombres(signosIds) {
      return signosIds
        .map(id => this.SIGNOS.find(s => s.id === id)?.txt || '')
        .filter(Boolean)
        .join(', ')
    },

    limpiarTodo() {
      this.data = {}
      this.activeZona = null
      this.$emit('input', this.data)
    },

    // Método para preparar y emitir los datos enriquecidos para la BD
    async guardar() {
      try {

        this.LoaderSpinnerShow();

        const enrichedData = {};

        for (const k in this.data) {
          const item = this.data[k]
          enrichedData[k] = {
            lado: item.lado,
            zona: item.zona,
            nombreZona: this.nombreZona(item.lado, item.zona),
            signos: item.signos,
            signosDetalle: item.signos.map(id => {
              const s = this.SIGNOS.find(x => x.id === id)
              return { id, txt: s ? s.txt : '' }
            })
          }
        }
        this.$emit('input', enrichedData)

        const payload = {
          hallazgos: enrichedData,
          observaciones: this.observaciones
        }

        const imagenPng = await this.exportarImagen();

        await examenClinicoMamaService.store(this.idHistoria, payload, imagenPng);

        Toast.fire({
          icon: 'success',
          title: 'Datos guardados correctamente'
        });

      } catch (e) {
        console.error(e);
        Toast.fire({
          icon: 'error',
          title: 'Ocurrio un error al procesar la solicitud'
        });
      } finally {
        this.LoaderSpinnerHide();
      }

    },

    // Método público para cargar datos previos
    async cargar() {
      try {
        this.LoaderSpinnerShow();
        const response = await examenClinicoMamaService.show(this.idHistoria);
        const detalles = response.data?.detalles;
        this.LoaderSpinnerHide();
        if (!detalles || detalles.length === 0) return;

        this.observaciones = response.data.observaciones ?? '';

        // Agrupar por clave lado_zona
        const agrupado = {};
        for (const d of detalles) {
          const k = `${d.lado}_${d.zona}`;
          if (!agrupado[k]) {
            agrupado[k] = {
              lado: d.lado,
              zona: d.zona,
              signos: []
            };
          }
          agrupado[k].signos.push(d.id_signo);
        }

        this.data = agrupado;

      } catch (e) {
        console.error('Error al cargar:', e);
        Toast.fire({
          icon: 'error',
          title: 'Ocurrio un error al procesar la solicitud'
        });
      } finally {
        this.LoaderSpinnerHide();
      }
    },
    // En el método save() o en un método exportar() del componente
    // En tu componente Vue, reemplaza exportarImagen() por esto:
    exportarImagen() {
      return new Promise((resolve) => {
        const svg = this.$el.querySelector('.silhouette-svg').cloneNode(true)

        // Eliminar la clase 'active' de todos los elementos para que no aparezca el foco de selección en la exportación
        svg.querySelectorAll('.active').forEach(el => el.classList.remove('active'))

        // Inyectar estilos inline para el export (sin redundancia pero con fidelidad)
        const style = document.createElement('style')
        style.innerHTML = `
      .zona { fill: transparent; }
      .zona.has-data { fill: rgba(23,130,210, 0.18); }
      .zona-pezon { fill: transparent; }
      .zona-pezon.has-data { fill: rgba(23,130,210, 0.3); stroke: rgba(23,130,210, 0.3); stroke-width: 1.5; }
      .zona-ext { fill: transparent; stroke: #C07040; stroke-width: 1.5; stroke-dasharray: 4,3; }
      .zona-ext.has-data { fill: rgba(23,130,210, 0.22); stroke: rgba(23,130,210, 0.3); stroke-dasharray: none; }
      .lbl { fill: #8B5035; font-size: 13px; font-weight: 800; text-anchor: middle; }
      .ext-lbl { fill: #7A5040; font-size: 11px; font-weight: 700; text-anchor: middle; }
    `
   svg.insertBefore(style, svg.firstChild)

        const serialized = new XMLSerializer().serializeToString(svg)
        const svgBlob = new Blob([serialized], { type: 'image/svg+xml;charset=utf-8' })
        const url = URL.createObjectURL(svgBlob)

        const img = new Image()
        img.onload = () => {
          const SCALE = 2       // ← ajusta entre 1.5 y 3 según calidad/peso deseado
  const W = 140
  const H = 137.5

  const canvas = document.createElement('canvas')
  canvas.width  = W * SCALE   // píxeles reales (alta densidad)
  canvas.height = H * SCALE

  const ctx = canvas.getContext('2d')
  ctx.scale(SCALE, SCALE)     // escala el dibujo
  ctx.drawImage(img, 0, 0, W, H)  // dibuja en espacio lógico


          URL.revokeObjectURL(url)
          canvas.toBlob((pngBlob) => {
            resolve(pngBlob)
          }, 'image/png')
        }

        img.onerror = (e) => {
          console.error('Error al exportar PNG:', e);
          URL.revokeObjectURL(url)
          resolve(null)
        }
 
        img.src = url
      })
    },
  },
  mounted() {
    this.cargar();
  }
}
</script>

<style scoped>
.mama-explorer {
  padding: 16px;
}

.titulo {
  font-size: 15px;
  font-weight: 500;
  margin: 0 0 16px;
  color: #222;
}

.main-grid {
  display: flex;
  gap: 20px;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
}

.mamas-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.silhouette-wrapper {
  position: relative;
  border-radius: 24px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  max-width: fit-content;
}

.silhouette-svg {
  width: 500px;
  height: auto;
  cursor: crosshair;
  overflow: visible;
  filter: drop-shadow(0 5px 15px rgba(0, 0, 0, 0.03));
}

.mamas-header {
  width: 560px;
  margin: 0 auto 10px;
  display: flex;
  justify-content: space-between;
  padding: 0 100px;
}

.side-label {
  font-weight: 700;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  font-size: 13px;
}

/* Estilos de Etiquetas */
.lbl {
  font-size: 14px;
  font-weight: 800;
  fill: #4d4545;
  pointer-events: none;
  text-anchor: middle;
  opacity: 0.9;
}

.ext-lbl {
  font-size: 12px;
  font-weight: 700;
  fill: #7A5040;
  pointer-events: none;
  text-anchor: middle;
}

/* Zonas Interactivas (Cuadrantes) */
.zona {
  fill: transparent;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}

.zona:hover {
  fill: rgba(23, 130, 210, 0.1);
}

.zona.has-data {
  fill: rgba(23, 130, 210, 0.2);
  stroke: rgba(23, 130, 210, 0.3);
  stroke-width: 1;
}

.zona.active {
  fill: rgba(23, 130, 210, 0.35);
  stroke: rgba(23, 130, 210, 0.3);
  stroke-width: 2;
  filter: drop-shadow(0 0 5px rgba(23, 130, 210, 0.4));
}

/* Zonas Pezón */
.zona-pezon {
  fill: transparent;
  transition: all 0.25s ease;
  cursor: pointer;
}

.zona-pezon:hover {
  fill: rgba(23, 130, 210, 0.15);
}

.zona-pezon.has-data {
  fill: rgba(23, 130, 210, 0.25);
  stroke: rgba(23, 130, 210, 0.3);
  stroke-width: 1.5;
}

.zona-pezon.active {
  fill: rgba(23, 130, 210, 0.45);
  stroke: rgba(23, 130, 210, 0.3);
  stroke-width: 2.5;
  filter: drop-shadow(0 0 8px rgba(23, 130, 210, 0.5));
}

/* Zonas Externas (Axilas, Clavículas) */
.zona-ext {
  fill: transparent;
  stroke: #C07040;
  stroke-width: 1.5;
  stroke-dasharray: 5, 4;
  cursor: pointer;
  transition: all 0.25s ease;
}

.zona-ext:hover {
  fill: rgba(23, 130, 210, 0.08);
  stroke-dasharray: none;
}

.zona-ext.has-data {
  fill: rgba(23, 130, 210, 0.2);
  stroke: rgba(23, 130, 210, 0.3);
  stroke-dasharray: none;
  stroke-width: 2;
}

.zona-ext.active {
  fill: rgba(23, 130, 210, 0.3);
  stroke: rgba(23, 130, 210, 0.3);
  stroke-width: 3;
  stroke-dasharray: none;
  filter: drop-shadow(0 0 6px rgba(23, 130, 210, 0.3));
}

/* Zonas externas SVG (axila, supraclavicular) */

.ext-btns-row {
  display: flex;
  gap: 20px;
  margin-top: 10px;
}

.ext-btns {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 180px;
}

.ext-btn {
  background: #fdfdfd;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 11.5px;
  cursor: pointer;
  text-align: left;
  transition: all .2s ease;
  color: #555;
}

.ext-btn:hover {
  background: #f0f7ff;
  color: #1782d2;
  border-color: #bcd9f5;
}

.ext-btn.has-data {
  border-color: #1782d2;
  color: #1782d2;
  background: #f0f7ff;
}

.ext-btn.active {
  background: #1782d2;
  border-color: #1782d2;
  color: #fff;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(23, 130, 210, 0.2);
}

.panel {
  width: 260px;
  border: 1px solid #eef0f2;
  border-radius: 12px;
  padding: 16px;
  background: #fff;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
}

.panel-t {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 6px;
  color: #333;
}

.panel-sub {
  font-size: 12px;
  color: #999;
  margin: 0 0 12px;
}

.zona-name {
  font-size: 12px;
  font-weight: 600;
  color: #1782d2;
  background: #f0f7ff;
  padding: 6px 12px;
  border-radius: 8px;
  margin-bottom: 12px;
  border: 1px solid #e0eeff;
}

.signos-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 400px;
  overflow-y: auto;
  padding-right: 4px;
}

.no-zona {
  font-size: 12px;
  color: #aaa;
  text-align: center;
  padding: 30px 0;
  margin: 0;
  font-style: italic;
}

.signo-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  background: #fff;
  cursor: pointer;
  transition: all .2s;
}

.signo-item:hover {
  border-color: #1782d2;
  background: #f9fcff;
}

.signo-item.sel {
  border-color: #1782d2;
  background: #f0f7ff;
}

.signo-check {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 2px solid #ddd;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .2s;
}

.signo-item.sel .signo-check {
  background: #1782d2;
  border-color: #1782d2;
}

.check-mark {
  width: 10px;
  height: 10px;
}

.signo-txt {
  font-size: 12px;
  color: #444;
  line-height: 1.4;
  flex: 1;
  word-break: break-word;
}

.signo-num {
  font-size: 11px;
  color: #ccc;
  font-weight: 600;
  flex-shrink: 0;
}

.resumen {
  margin-top: 20px;
  border-top: 1px solid #f0f0f0;
  padding-top: 16px;
}

.resumen-t {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  margin-bottom: 10px;
}

.res-item {
  font-size: 11.5px;
  padding: 8px 0;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.res-zona {
  color: #1782d2;
  font-weight: 700;
  width: 100%;
  word-break: break-word;
}

.res-signos {
  color: #666;
  line-height: 1.4;
  word-break: break-word;
  padding-left: 2px;
}

.clear-btn {
  margin-top: 12px;
  width: 100%;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 8px;
  font-size: 12px;
  color: #999;
  cursor: pointer;
  transition: all .2s;
}

.clear-btn:hover {
  background: #fff1f1;
  color: #ef4444;
  border-color: #fecaca;
}
</style>